import type {ComboboxItem} from '@mantine/core';
import {AttachmentModuleEnum} from 'src/api/ProactApiClient';

export const attachmentModuleEnumOptions: ComboboxItem[] = [
  {value: String(AttachmentModuleEnum.Asset), label: 'Asset'},
  {value: String(AttachmentModuleEnum.Vendor), label: 'Vendor'},
  {value: String(AttachmentModuleEnum.User), label: 'User'},
  {value: String(AttachmentModuleEnum.SafetyEvent), label: 'Safety Event'},
  {
    value: String(AttachmentModuleEnum.CourseAssignment),
    label: 'Course Assignment',
  },
  {
    value: String(AttachmentModuleEnum.CourseClassroom),
    label: 'Course Classroom',
  },
  {
    value: String(AttachmentModuleEnum.TaskDefinition),
    label: 'Task Definition',
  },
  {
    value: String(AttachmentModuleEnum.ItemDefinition),
    label: 'Item Definition',
  },
  {
    value: String(AttachmentModuleEnum.ItemAssignment),
    label: 'Item Assignment',
  },
];
